import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCalendar, FiUser, FiTag, FiArrowRight, FiSearch, FiTrendingUp, FiLeaf, FiShield } = FiIcons;

const Blog = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('alle');

  const categories = [
    { id: 'alle', name: 'Alle Artikel', icon: FiTrendingUp },
    { id: 'reinigung', name: 'Reinigung', icon: FiShield },
    { id: 'technik', name: 'Technik', icon: FiTrendingUp },
    { id: 'nachhaltigkeit', name: 'Nachhaltigkeit', icon: FiLeaf },
    { id: 'tipps', name: 'Tipps & Tricks', icon: FiUser }
  ];

  const blogPosts = [
    {
      id: 1,
      title: 'Nachhaltige Reinigung: Umweltfreundliche Lösungen für Ihr Gebäude',
      excerpt: 'Erfahren Sie, wie Sie mit nachhaltigen Reinigungsmethoden nicht nur die Umwelt schonen, sondern auch Kosten sparen können.',
      content: 'Nachhaltigkeit wird in der Gebäudereinigung immer wichtiger. Moderne, umweltfreundliche Reinigungsmittel und -verfahren bieten nicht nur ökologische Vorteile...',
      image: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      author: 'Sarah Tex',
      date: new Date('2024-01-15'),
      category: 'nachhaltigkeit',
      tags: ['Umwelt', 'Kosten sparen', 'Green Building'],
      readTime: '5 min'
    },
    {
      id: 2,
      title: 'Smart Building: Wie IoT das Facility Management revolutioniert',
      excerpt: 'Internet of Things (IoT) Sensoren ermöglichen es, Gebäude intelligent zu überwachen und Wartungsarbeiten präventiv zu planen.',
      content: 'Die Digitalisierung macht auch vor dem Facility Management nicht halt. IoT-Sensoren sammeln kontinuierlich Daten über Temperatur, Luftfeuchtigkeit...',
      image: 'https://images.unsplash.com/photo-1518709268805-4e9042af2176?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      author: 'Thomas Hubler',
      date: new Date('2024-01-10'),
      category: 'technik',
      tags: ['IoT', 'Digitalisierung', 'Predictive Maintenance'],
      readTime: '7 min'
    },
    {
      id: 3,
      title: '5 Tipps für eine effiziente Büroreinigung',
      excerpt: 'Mit diesen bewährten Methoden optimieren Sie Ihre Büroreinigung und sorgen für ein gesundes Arbeitsumfeld.',
      content: 'Eine saubere Arbeitsumgebung ist entscheidend für Produktivität und Mitarbeiterzufriedenheit. Hier sind fünf bewährte Strategien...',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      author: 'Michael Weber',
      date: new Date('2024-01-05'),
      category: 'reinigung',
      tags: ['Büro', 'Effizienz', 'Gesundheit'],
      readTime: '4 min'
    },
    {
      id: 4,
      title: 'Energieeffizienz in Gebäuden: Potenziale und Maßnahmen',
      excerpt: 'Durch gezielte Maßnahmen können Sie den Energieverbrauch Ihres Gebäudes um bis zu 30% reduzieren.',
      content: 'Energieeffizienz ist nicht nur gut für die Umwelt, sondern auch für Ihr Budget. Moderne Gebäudetechnik bietet zahlreiche Möglichkeiten...',
      image: 'https://images.unsplash.com/photo-1473341304170-971dccb5ac1e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      author: 'Julia Steiner',
      date: new Date('2024-01-01'),
      category: 'nachhaltigkeit',
      tags: ['Energie', 'Kostenersparnis', 'Klimaschutz'],
      readTime: '6 min'
    },
    {
      id: 5,
      title: 'Winterdienst richtig planen: Checkliste für Facility Manager',
      excerpt: 'Eine gute Vorbereitung ist das A und O für einen erfolgreichen Winterdienst. Unsere Checkliste hilft Ihnen dabei.',
      content: 'Der Winter stellt besondere Anforderungen an das Facility Management. Eine rechtzeitige Planung und die richtige Ausrüstung...',
      image: 'https://images.unsplash.com/photo-1578662996442-48f60103fc96?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      author: 'Carmen López',
      date: new Date('2023-12-20'),
      category: 'tipps',
      tags: ['Winter', 'Sicherheit', 'Planung'],
      readTime: '5 min'
    },
    {
      id: 6,
      title: 'Hygiene am Arbeitsplatz: Standards nach Corona',
      excerpt: 'Die Pandemie hat die Hygienestandards dauerhaft verändert. Was Facility Manager jetzt beachten müssen.',
      content: 'COVID-19 hat das Bewusstsein für Hygiene am Arbeitsplatz geschärft. Viele der eingeführten Maßnahmen sind gekommen, um zu bleiben...',
      image: 'https://images.unsplash.com/photo-1584744982491-665216d95f8b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
      author: 'Dr. Anna Schmidt',
      date: new Date('2023-12-15'),
      category: 'reinigung',
      tags: ['Hygiene', 'Gesundheit', 'Corona'],
      readTime: '8 min'
    }
  ];

  const filteredPosts = blogPosts.filter(post => {
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesCategory = selectedCategory === 'alle' || post.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const featuredPost = blogPosts[0];
  const recentPosts = blogPosts.slice(1, 4);

  return (
    <div>
      {/* Hero Section */}
      <section className="relative py-16 sm:py-20 bg-gradient-to-r from-orange-500 to-orange-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center text-white"
          >
            <h1 className="text-4xl sm:text-5xl font-bold mb-6">Blog & News</h1>
            <p className="text-lg sm:text-xl max-w-3xl mx-auto">
              Bleiben Sie informiert über die neuesten Trends und Entwicklungen im Facility Management.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Featured Post */}
      <section className="py-16 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="mb-12 sm:mb-16"
          >
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-6 sm:mb-8 text-center">Aktueller Hauptartikel</h2>
            <div className="bg-white rounded-xl shadow-lg overflow-hidden">
              <div className="md:flex">
                <div className="md:w-1/2">
                  <img src={featuredPost.image} alt={featuredPost.title} className="w-full h-48 sm:h-64 md:h-full object-cover" />
                </div>
                <div className="md:w-1/2 p-6 sm:p-8">
                  <div className="flex flex-wrap items-center gap-2 sm:gap-4 mb-3 sm:mb-4 text-xs sm:text-sm text-gray-600">
                    <div className="flex items-center space-x-1">
                      <SafeIcon icon={FiCalendar} className="w-3 h-3 sm:w-4 sm:h-4" />
                      <span>{format(featuredPost.date, 'dd. MMMM yyyy', { locale: de })}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <SafeIcon icon={FiUser} className="w-3 h-3 sm:w-4 sm:h-4" />
                      <span>{featuredPost.author}</span>
                    </div>
                    <span className="text-orange-500">{featuredPost.readTime} Lesezeit</span>
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">
                    {featuredPost.title}
                  </h3>
                  <p className="text-gray-600 mb-4 sm:mb-6 text-sm sm:text-base">
                    {featuredPost.excerpt}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-4 sm:mb-6">
                    {featuredPost.tags.map((tag, index) => (
                      <span key={index} className="px-2 sm:px-3 py-1 bg-orange-100 text-orange-700 text-xs sm:text-sm rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                  <button className="bg-orange-500 hover:bg-orange-600 text-white px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold transition-colors duration-200 flex items-center space-x-2 text-sm sm:text-base">
                    <span>Artikel lesen</span>
                    <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Search and Filter */}
      <section className="py-8 sm:py-12 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-6 items-center justify-between">
            {/* Search */}
            <div className="relative flex-1 max-w-md w-full">
              <SafeIcon icon={FiSearch} className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
              <input
                type="text"
                placeholder="Artikel durchsuchen..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="w-full pl-9 sm:pl-10 pr-4 py-2 sm:py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500 transition-colors text-sm sm:text-base"
              />
            </div>
            {/* Category Filter */}
            <div className="flex flex-wrap gap-2 justify-center lg:justify-start">
              {categories.map((category) => (
                <button
                  key={category.id}
                  onClick={() => setSelectedCategory(category.id)}
                  className={`px-3 sm:px-4 py-2 rounded-lg font-semibold transition-colors duration-200 flex items-center space-x-2 text-sm sm:text-base ${selectedCategory === category.id
                    ? 'bg-orange-500 text-white'
                    : 'bg-white text-gray-700 hover:bg-orange-50'
                    }`}
                >
                  <SafeIcon icon={category.icon} className="w-3 h-3 sm:w-4 sm:h-4" />
                  <span>{category.name}</span>
                </button>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-12 sm:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {filteredPosts.map((post, index) => (
              <motion.article
                key={post.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300"
              >
                <img src={post.image} alt={post.title} className="w-full h-48 object-cover" />
                <div className="p-4 sm:p-6">
                  <div className="flex flex-wrap items-center gap-2 sm:gap-4 mb-2 sm:mb-3 text-xs sm:text-sm text-gray-600">
                    <div className="flex items-center space-x-1">
                      <SafeIcon icon={FiCalendar} className="w-3 h-3 sm:w-4 sm:h-4" />
                      <span>{format(post.date, 'dd.MM.yyyy')}</span>
                    </div>
                    <div className="flex items-center space-x-1">
                      <SafeIcon icon={FiUser} className="w-3 h-3 sm:w-4 sm:h-4" />
                      <span>{post.author}</span>
                    </div>
                    <span className="text-orange-500">{post.readTime}</span>
                  </div>
                  <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3 line-clamp-2">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-3 sm:mb-4 line-clamp-3 text-sm sm:text-base">
                    {post.excerpt}
                  </p>
                  <div className="flex flex-wrap gap-2 mb-3 sm:mb-4">
                    {post.tags.slice(0, 2).map((tag, tagIndex) => (
                      <span key={tagIndex} className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded">
                        {tag}
                      </span>
                    ))}
                    {post.tags.length > 2 && (
                      <span className="px-2 py-1 bg-gray-100 text-gray-700 text-xs rounded">
                        +{post.tags.length - 2}
                      </span>
                    )}
                  </div>
                  <button className="text-orange-500 hover:text-orange-600 font-semibold flex items-center space-x-2 transition-colors text-sm sm:text-base">
                    <span>Weiterlesen</span>
                    <SafeIcon icon={FiArrowRight} className="w-4 h-4" />
                  </button>
                </div>
              </motion.article>
            ))}
          </div>
          {filteredPosts.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-600 text-lg">
                Keine Artikel gefunden. Versuchen Sie andere Suchbegriffe oder Filter.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* Newsletter Signup */}
      <section className="py-16 sm:py-20 bg-orange-500">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="text-center text-white"
          >
            <h2 className="text-3xl sm:text-4xl font-bold mb-6">Bleiben Sie informiert</h2>
            <p className="text-lg sm:text-xl mb-6 sm:mb-8 max-w-3xl mx-auto">
              Abonnieren Sie unseren Newsletter und erhalten Sie regelmäßig wertvolle Tipps und Updates zum Facility Management.
            </p>
            <div className="max-w-md mx-auto flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="Ihre E-Mail-Adresse"
                className="flex-1 px-4 py-2 sm:py-3 rounded-lg text-gray-900 focus:ring-2 focus:ring-white focus:outline-none text-sm sm:text-base"
              />
              <button className="bg-white text-orange-500 hover:bg-gray-100 px-4 sm:px-6 py-2 sm:py-3 rounded-lg font-semibold transition-colors duration-200 text-sm sm:text-base">
                Abonnieren
              </button>
            </div>
            <p className="text-orange-100 text-sm mt-4">Kein Spam. Abmeldung jederzeit möglich.</p>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default Blog;